import { useEffect, useState } from 'react'
import { db } from '../firebase/config'
import { client } from './Client'

// Reverse-lookup: zoekt het Partner-record waarvan `networkCompagnyID` gelijk
// is aan de CompagnyID van de huidige tenant. Bedoeld voor portfolio-tenants
// die zelf óók een partner zijn (e.g. TOSS). Geen extra UI-koppeling nodig —
// de super-admin zet `networkCompagnyID` al in Settings → Partners.
//
// Returnt `{ ownPartner, loading, error }`:
//   - ownPartner = doc of null
//   - loading = true tijdens fetch
//   - error = string als de query faalt (bv. list-rule blokkeert)
//
// Spec: docs/features/onboarding-flow.md (auto-detect partner in NewProjectModal)
const useOwnPartner = () => {

    const [ownPartner, setOwnPartner] = useState(null)
    const [loading, setLoading] = useState(!!client)
    const [error, setError] = useState(null)

    useEffect(() => {

        if (!client) {
            setOwnPartner(null)
            setLoading(false)
            return
        }

        setLoading(true)

        const unsub = db.collection('Partners')
            .where('networkCompagnyID', '==', client)
            .limit(2)
            .onSnapshot(
                (snap) => {
                    if (snap.empty) {
                        setOwnPartner(null)
                    } else {
                        if (snap.size > 1) {
                            console.warn('useOwnPartner: meerdere Partners verwijzen naar deze tenant, eerste gebruikt', client)
                        }
                        const doc = snap.docs[0]
                        setOwnPartner({ ...doc.data(), docid: doc.id })
                    }
                    setError(null)
                    setLoading(false)
                },
                (err) => {
                    console.error('useOwnPartner query faalde', err)
                    setOwnPartner(null)
                    setError(err?.message || 'Partner-lookup mislukt')
                    setLoading(false)
                }
            )

        return () => unsub()

    }, [])

    return { ownPartner, loading, error }

}

export default useOwnPartner
